import React from "react";
import PropTypes from "prop-types";
import CogImage from "@learningblocks/exp-constants/lib/Images/mc_settings_icon.svg";
import { Image } from "@learningblocks/shared-components/lib/Image";

import "./style.scss";

const TRANSLATION_KEY = {
  PowerSupplySettings: "PowerSupplySettings.string",
};

/**
 * Hover:
 *   Component to render tooltip on hover state
 */

export function Hover(props) {
  return (
    <div
      className="ps_tooltip_hover"
      onClick={props.onClick}
      role="button"
      tabIndex="0"
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          props.onClick;
        }
      }}
    >
      <Image
        className="ps_tooltip_hover_icon"
        src={CogImage}
        alt={TRANSLATION_KEY.PowerSupplySettings}
      />
    </div>
  );
}

Hover.propTypes = {
  /**
   * callback function to trigger on click
   */
  onClick: PropTypes.func,
};
